// extracted by mini-css-extract-plugin
export default {"form-header":"style_form-header__gwT8p","form":"style_form__P6Z3X","form-footer":"style_form-footer__8Ch2u","bt-add-site":"style_bt-add-site__xEPBz"};